import React from 'react'
import { observer } from 'mobx-react-lite'

import { ListItem, ListItemText } from '@material-ui/core'

import { DropdownButton } from './DropdownButton'

import { useApi, useStore } from '../hooks/storeHook'
import { useDefaultMenuItemStyles } from '../hooks/defaultSelectStylesHook'

import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'

interface ExportProductsButtonProps {
  text?: string,

  width?: number

  integrationType?: IntegrationType

  accountId?: number
}

export const ExportProductsButton =
  observer(({
    text = 'Экспорт',
    width,
    integrationType: integrationTypeProp,
    accountId: accountIdProp
  }: ExportProductsButtonProps) => {
    const menuClasses = useDefaultMenuItemStyles()

    const api = useApi()

    const store = useStore()
    const {hasMoySkladApp} = store

    const integrationType = integrationTypeProp ?? store.navState.integrationType
    const accountId = accountIdProp ?? store.navState.accountId

    let exportUrl = api.product.exportAllToXlsUrl(integrationType, accountId)

    if (hasMoySkladApp && api.headerAuthToken != null) {
      exportUrl += `${(exportUrl.includes('?') ? '&' : '?')}Authorization=${encodeURIComponent(api.headerAuthToken)}`
    }

    return (
      <DropdownButton text={text} popupWidth={width ?? 120} width={width}>
        {
          buttonProps =>
            <ListItem
              className={menuClasses.menuItem}
              button
              component="a"
              href={exportUrl}
              target="_blank"
              onClick={buttonProps.setClosed}
            >
              <ListItemText primary="В файл .xls"/>
            </ListItem>
        }
      </DropdownButton>
    )
  })